<mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
  <span class="font-size-16 font-weight-400">
    {{ 'MAINTENANCES.FILTERS.TITLE' | translate }}
  </span>
</mat-toolbar>

<form class="filter-content" [formGroup]="filtersForm" fusePerfectScrollbar *ngIf="filtersForm" autocomplete="off">
  <div class="filter-subtitle" [translate]="'MAINTENANCES.FILTERS.PERIOD_CREATE'">Filter by period</div>

  <mat-list>
    <mat-list-item>
      <table width="100%">
        <tr>
          <td width="15%">
            <label class="filter-date-label" [translate]="'MAINTENANCES.FILTERS.FROM'"> From: </label>
          </td>
          <td width="85%">
            <button mat-icon-button (click)="openedAtGte.open()">
              <i class="angularjs-fuse-icon icon-calendar-today"></i>
            </button>
            <mat-form-field appearance="standard" class="datepicker">
              <input
                placeholder="{{ 'MAINTENANCES.OPENED_DATE' | translate }}"
                matInput
                [max]="filtersForm.get('openedAtLte').value"
                [matDatepicker]="openedAtGte"
                formControlName="openedAtGte"
              />
              <mat-datepicker-toggle matSuffix [for]="openedAtGte">
                <mat-icon aria-hidden="false" matDatepickerToggleIcon>arrow_drop_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #openedAtGte></mat-datepicker>

              <mat-error *ngIf="filtersForm.get('openedAtGte').hasError('invalidDate')">
                {{ 'MAINTENANCES.ERRORS.INVALID_DATE' | translate }}
              </mat-error>
              <mat-error *ngIf="filtersForm.get('openedAtGte').hasError('invalidPeriod')">
                {{ 'MAINTENANCES.ERRORS.INVALID_DIFF' | translate }}
              </mat-error>
              <mat-error *ngIf="filtersForm.get('openedAtLte').hasError('invalidRange')">
                {{ 'MAINTENANCES.ERRORS.INVALID_RANGE' | translate }}
              </mat-error>
              <mat-error *ngIf="filtersForm.get('openedAtLte').errors?.required">
                {{ 'MAINTENANCES.ERRORS.DATE_REQUIRED' | translate }}
              </mat-error>
            </mat-form-field>
          </td>
        </tr>
      </table>
    </mat-list-item>
    <mat-list-item>
      <table width="100%">
        <tr>
          <td width="15%">
            <label class="filter-date-label" [translate]="'MAINTENANCES.FILTERS.UNTIL'"> Until: </label>
          </td>
          <td width="85%">
            <button mat-icon-button (click)="openedAtLte.open()">
              <i class="angularjs-fuse-icon icon-calendar-today"></i>
            </button>
            <mat-form-field appearance="standard" class="datepicker">
              <input
                placeholder="{{ 'MAINTENANCES.OPENED_DATE' | translate }}"
                matInput
                [min]="filtersForm.get('openedAtGte').value"
                [matDatepicker]="openedAtLte"
                formControlName="openedAtLte"
              />
              <mat-datepicker-toggle matSuffix [for]="openedAtLte">
                <mat-icon aria-hidden="false" matDatepickerToggleIcon>arrow_drop_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #openedAtLte></mat-datepicker>

              <mat-error *ngIf="filtersForm.get('openedAtLte').hasError('invalidDate')">
                {{ 'MAINTENANCES.ERRORS.INVALID_DATE' | translate }}
              </mat-error>
              <mat-error *ngIf="filtersForm.get('openedAtLte').hasError('invalidPeriod')">
                {{ 'MAINTENANCES.ERRORS.INVALID_DIFF' | translate }}
              </mat-error>
              <mat-error *ngIf="filtersForm.get('openedAtLte').hasError('invalidRange')">
                {{ 'MAINTENANCES.ERRORS.INVALID_RANGE' | translate }}
              </mat-error>
              <mat-error *ngIf="filtersForm.get('openedAtLte').errors?.required">
                {{ 'MAINTENANCES.ERRORS.DATE_REQUIRED' | translate }}
              </mat-error>
            </mat-form-field>
          </td>
        </tr>
      </table>
    </mat-list-item>
  </mat-list>

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16" [translate]="'MAINTENANCES.FILTERS.PERIOD_DONE'">Filter by period</div>

  <mat-list>
    <mat-list-item>
      <table width="100%">
        <tr>
          <td width="15%">
            <label class="filter-date-label" [translate]="'MAINTENANCES.FILTERS.FROM'"> From: </label>
          </td>
          <td width="85%">
            <button mat-icon-button (click)="closedAtGte.open()">
              <i class="angularjs-fuse-icon icon-calendar-today"></i>
            </button>
            <mat-form-field appearance="standard" class="datepicker">
              <input
                placeholder="{{ 'MAINTENANCES.DONE_DATE' | translate }}"
                matInput
                [max]="filtersForm.get('closedAtLte').value"
                [matDatepicker]="closedAtGte"
                formControlName="closedAtGte"
              />
              <mat-datepicker-toggle matSuffix [for]="closedAtGte">
                <mat-icon aria-hidden="false" matDatepickerToggleIcon>arrow_drop_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #closedAtGte></mat-datepicker>

              <mat-error *ngIf="filtersForm.get('closedAtGte').hasError('invalidDate')">
                {{ 'MAINTENANCES.ERRORS.INVALID_DATE' | translate }}
              </mat-error>
              <mat-error *ngIf="filtersForm.get('closedAtGte').hasError('invalidPeriod')">
                {{ 'MAINTENANCES.ERRORS.INVALID_DIFF' | translate }}
              </mat-error>
            </mat-form-field>
          </td>
        </tr>
      </table>
    </mat-list-item>
    <mat-list-item>
      <table width="100%">
        <tr>
          <td width="15%">
            <label class="filter-date-label" [translate]="'MAINTENANCES.FILTERS.UNTIL'"> Until: </label>
          </td>
          <td width="85%">
            <button mat-icon-button (click)="closedAtLte.open()">
              <i class="angularjs-fuse-icon icon-calendar-today"></i>
            </button>
            <mat-form-field appearance="standard" class="datepicker">
              <input
                placeholder="{{ 'MAINTENANCES.DONE_DATE' | translate }}"
                matInput
                [min]="filtersForm.get('closedAtGte').value"
                [matDatepicker]="closedAtLte"
                formControlName="closedAtLte"
              />
              <mat-datepicker-toggle matSuffix [for]="closedAtLte">
                <mat-icon aria-hidden="false" matDatepickerToggleIcon>arrow_drop_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #closedAtLte></mat-datepicker>

              <mat-error *ngIf="filtersForm.get('closedAtLte').hasError('invalidDate')">
                {{ 'MAINTENANCES.ERRORS.INVALID_DATE' | translate }}
              </mat-error>
              <mat-error *ngIf="filtersForm.get('closedAtLte').hasError('invalidPeriod')">
                {{ 'MAINTENANCES.ERRORS.INVALID_DIFF' | translate }}
              </mat-error>
            </mat-form-field>
          </td>
        </tr>
      </table>
    </mat-list-item>
  </mat-list>

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16" [translate]="'MAINTENANCES.FILTERS.PERIOD_SCHEDULED'">Filter by period</div>

  <mat-list>
    <mat-list-item>
      <table width="100%">
        <tr>
          <td width="15%">
            <label class="filter-date-label" [translate]="'MAINTENANCES.FILTERS.FROM'"> From: </label>
          </td>
          <td width="85%">
            <button mat-icon-button (click)="scheduledAtGte.open()">
              <i class="angularjs-fuse-icon icon-calendar-today"></i>
            </button>
            <mat-form-field appearance="standard" class="datepicker">
              <input
                placeholder="{{ 'MAINTENANCES.SCHEDULED_DATE' | translate }}"
                matInput
                [max]="filtersForm.get('scheduledAtLte').value"
                [matDatepicker]="scheduledAtGte"
                formControlName="scheduledAtGte"
              />
              <mat-datepicker-toggle matSuffix [for]="scheduledAtGte">
                <mat-icon aria-hidden="false" matDatepickerToggleIcon>arrow_drop_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #scheduledAtGte></mat-datepicker>

              <mat-error *ngIf="filtersForm.get('scheduledAtGte').hasError('invalidDate')">
                {{ 'MAINTENANCES.ERRORS.INVALID_DATE' | translate }}
              </mat-error>
              <mat-error *ngIf="filtersForm.get('scheduledAtGte').hasError('invalidPeriod')">
                {{ 'MAINTENANCES.ERRORS.INVALID_DIFF' | translate }}
              </mat-error>
            </mat-form-field>
          </td>
        </tr>
      </table>
    </mat-list-item>

    <mat-list-item>
      <table width="100%">
        <tr>
          <td width="15%">
            <label class="filter-date-label" [translate]="'MAINTENANCES.FILTERS.UNTIL'"> Until: </label>
          </td>
          <td width="85%">
            <button mat-icon-button (click)="scheduledAtLte.open()">
              <i class="angularjs-fuse-icon icon-calendar-today"></i>
            </button>
            <mat-form-field appearance="standard" class="datepicker">
              <input
                placeholder="{{ 'MAINTENANCES.SCHEDULED_DATE' | translate }}"
                matInput
                [min]="filtersForm.get('scheduledAtGte').value"
                [matDatepicker]="scheduledAtLte"
                formControlName="scheduledAtLte"
              />
              <mat-datepicker-toggle matSuffix [for]="scheduledAtLte">
                <mat-icon aria-hidden="false" matDatepickerToggleIcon>arrow_drop_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #scheduledAtLte></mat-datepicker>

              <mat-error *ngIf="filtersForm.get('scheduledAtLte').hasError('invalidDate')">
                {{ 'MAINTENANCES.ERRORS.INVALID_DATE' | translate }}
              </mat-error>
              <mat-error *ngIf="filtersForm.get('scheduledAtLte').hasError('invalidPeriod')">
                {{ 'MAINTENANCES.ERRORS.INVALID_DIFF' | translate }}
              </mat-error>
            </mat-form-field>
          </td>
        </tr>
      </table>
    </mat-list-item>
  </mat-list>

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16" [translate]="'MAINTENANCES.FILTERS.ACTIVE_OR_INACTIVE'">
    Filter by actives or inactives
  </div>

  <mat-form-field class="w-100-p" appearance="legacy">
    <mat-select formControlName="archived">
      <mat-option [value]="false">
        {{ 'MAINTENANCES.FILTERS.ACTIVE' | translate }}
      </mat-option>
      <mat-option [value]="true">
        {{ 'MAINTENANCES.FILTERS.INACTIVE' | translate }}
      </mat-option>
      <mat-option [value]="''">
        {{ 'MAINTENANCES.FILTERS.ALL' | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-divider class="mt-16"></mat-divider>

  <ng-container *ngIf="hasFlagWarranties">
    <mat-divider class="mt-16"></mat-divider>
    <div class="filter-subtitle mt-16" [translate]="'MAINTENANCES.FILTERS.WARRANTY.PERIOD'">Filter by warranty</div>

    <mat-list>
      <mat-list-item>
        <table width="100%">
          <tr>
            <td width="15%">
              <label class="filter-date-label" [translate]="'MAINTENANCES.FILTERS.FROM'"> From: </label>
            </td>
            <td width="85%">
              <button mat-icon-button (click)="warrantyStartDateLte.open()">
                <i class="angularjs-fuse-icon icon-calendar-today"></i>
              </button>
              <mat-form-field appearance="standard" class="datepicker">
                <input
                  placeholder="{{ 'MAINTENANCES.FILTERS.WARRANTY.WARRANTY_FROM' | translate }}"
                  matInput
                  [max]="filtersForm.get('warrantyEndDateGte').value"
                  [matDatepicker]="warrantyStartDateLte"
                  formControlName="warrantyStartDateLte"
                />
                <mat-datepicker-toggle matSuffix [for]="warrantyStartDateLte">
                  <mat-icon aria-hidden="false" matDatepickerToggleIcon>arrow_drop_down</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #warrantyStartDateLte></mat-datepicker>

                <mat-error *ngIf="filtersForm.get('warrantyStartDateLte').hasError('invalidDate')">
                  {{ 'MAINTENANCES.ERRORS.INVALID_DATE' | translate }}
                </mat-error>
                <mat-error *ngIf="filtersForm.get('warrantyStartDateLte').hasError('invalidPeriod')">
                  {{ 'MAINTENANCES.ERRORS.INVALID_DIFF' | translate }}
                </mat-error>
              </mat-form-field>
            </td>
          </tr>
        </table>
      </mat-list-item>

      <mat-list-item>
        <table width="100%">
          <tr>
            <td width="15%">
              <label class="filter-date-label" [translate]="'MAINTENANCES.FILTERS.UNTIL'"> Until: </label>
            </td>
            <td width="85%">
              <button mat-icon-button (click)="warrantyEndDateGte.open()">
                <i class="angularjs-fuse-icon icon-calendar-today"></i>
              </button>
              <mat-form-field appearance="standard" class="datepicker">
                <input
                  placeholder="{{ 'MAINTENANCES.FILTERS.WARRANTY.WARRANTY_UNTIL' | translate }}"
                  matInput
                  [min]="filtersForm.get('warrantyStartDateLte').value"
                  [matDatepicker]="warrantyEndDateGte"
                  formControlName="warrantyEndDateGte"
                />
                <mat-datepicker-toggle matSuffix [for]="warrantyEndDateGte">
                  <mat-icon aria-hidden="false" matDatepickerToggleIcon>arrow_drop_down</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #warrantyEndDateGte></mat-datepicker>

                <mat-error *ngIf="filtersForm.get('warrantyEndDateGte').hasError('invalidDate')">
                  {{ 'MAINTENANCES.ERRORS.INVALID_DATE' | translate }}
                </mat-error>
                <mat-error *ngIf="filtersForm.get('warrantyEndDateGte').hasError('invalidPeriod')">
                  {{ 'MAINTENANCES.ERRORS.INVALID_DIFF' | translate }}
                </mat-error>
              </mat-form-field>
            </td>
          </tr>
        </table>
      </mat-list-item>
    </mat-list>

    <mat-divider class="mt-16"></mat-divider>
    <div class="filter-subtitle mt-16">
      {{ 'MAINTENANCES.FILTERS.WARRANTY.STATUS' | translate }}
    </div>

    <div class="filter-checkbox" formArrayName="warrantyStatusIn">
      <mat-checkbox
        *ngFor="let status of warrantyStatus; index as $index"
        labelPosition="before"
        [formControlName]="$index"
      >
        <div class="warranty-status" [ngClass]="'warranty-status--' + status"></div>
        {{ 'MAINTENANCES.FILTERS.WARRANTY_STATUS.' + status.toUpperCase() | translate }}
      </mat-checkbox>
    </div>
  </ng-container>

  <div class="filter-subtitle mt-16" [translate]="'MAINTENANCES.FILTERS.EQUIPMENTS_PRESENCE'">
    Filter by the presence of equipments
  </div>

  <mat-form-field class="w-100-p" appearance="legacy">
    <mat-select formControlName="hasEquipments">
      <mat-option [value]="true">
        {{ 'MAINTENANCES.FILTERS.WITH_EQUIPMENTS' | translate }}
      </mat-option>
      <mat-option [value]="false">
        {{ 'MAINTENANCES.FILTERS.WITHOUT_EQUIPMENTS' | translate }}
      </mat-option>
      <mat-option [value]="''">
        {{ 'MAINTENANCES.FILTERS.ALL' | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-divider class="mt-16"></mat-divider>

  <input
    class="mt-16 input-legacy"
    formControlName="number"
    name="number"
    placeholder="{{ 'MAINTENANCES.NUMBER_PLACEHOLDER' | translate }}"
  />

  <mat-divider class="mt-16"></mat-divider>

  <input
    class="mt-16 input-legacy"
    formControlName="message"
    name="message"
    placeholder="{{ 'MAINTENANCES.MESSAGE_PLACEHOLDER' | translate }}"
  />

  <mat-divider class="mt-16"></mat-divider>

  <div class="mt-16">
    <fc-locations-input
      class="fc-segments-input"
      [control]="filtersForm.get('locations')"
      [desiredStyle]="desiredStyle"
    ></fc-locations-input>
  </div>

  <mat-divider class="mt-16"></mat-divider>

  <equipment-legacy class="mt-16" formControlName="equipmentId"></equipment-legacy>

  <mat-divider class="mt-16"></mat-divider>

  <div class="mt-16">
    <fc-segments-input
      class="fc-segments-input"
      [control]="filtersForm.get('segments')"
      [shouldDisplayArchived]="false"
      [desiredStyle]="desiredStyle"
    ></fc-segments-input>
  </div>

  <mat-divider class="mt-16"></mat-divider>

  <div class="mt-16">
    <fc-companies-input
      [desiredStyle]="desiredStyle"
      class="fc-segments-input"
      [control]="filtersForm.get('companies')"
    ></fc-companies-input>
  </div>

  <mat-divider class="mt-16"></mat-divider>

  <div class="mt-16">
    <fc-requesters-input
      [desiredStyle]="desiredStyle"
      class="fc-segments-input"
      [control]="filtersForm.get('requesters')"
    ></fc-requesters-input>
  </div>

  <mat-divider class="mt-16"></mat-divider>

  <div class="mt-16">
    <fc-pendency-types-input
      class="fc-segments-input"
      [control]="filtersForm.get('pendenciesTypes')"
      [shouldDisplayArchived]="false"
      [desiredStyle]="desiredStyle"
    ></fc-pendency-types-input>
  </div>

  <mat-divider class="mt-16"></mat-divider>

  <input
    class="mt-16 input-legacy"
    formControlName="formContent"
    name="formContent"
    placeholder="{{ 'MAINTENANCES.FORM_CONTENT_PLACEHOLDER' | translate }}"
  />

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16" [translate]="'MAINTENANCES.FILTERS.PAYMENT_STATUS'">Filter by payment status</div>

  <div class="filter-checkbox" formArrayName="paymentStatus">
    <mat-checkbox
      *ngFor="let paymentStatus of PAYMENT_STATUS; let $index = index"
      labelPosition="before"
      [formControlName]="$index"
    >
      <div class="payment-status-label" [ngClass]="'payment-status-label--' + (paymentStatus | camelToKebabCase)"></div>
      {{ paymentStatus | paymentStatus }}
    </mat-checkbox>
  </div>

  <mat-divider class="mt-16"></mat-divider>

  <input
    class="mt-16 input-legacy"
    formControlName="paymentNumber"
    name="paymentNumber"
    placeholder="{{ 'MAINTENANCES.PAYMENT_NUMBER_PLACEHOLDER' | translate }}"
  />

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16" [translate]="'MAINTENANCES.FILTERS.PENDENCIES.TREATMENT_STATUS'">
    Filter by handling of pendencies
  </div>

  <mat-form-field class="w-100-p" appearance="legacy">
    <mat-select formControlName="pendenciesTreatmentStatus">
      <mat-option [value]="['enterprise']">
        {{ 'MAINTENANCES.TABS.PENDENCIES.TREATMENT_STATUS.ENTERPRISE' | translate }}
      </mat-option>
      <mat-option [value]="['company']">
        {{ 'MAINTENANCES.TABS.PENDENCIES.TREATMENT_STATUS.COMPANY' | translate }}
      </mat-option>
      <mat-option [value]="''">
        {{ 'MAINTENANCES.FILTERS.ALL' | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16" [translate]="'MAINTENANCES.FILTERS.PENDENCIES.STATUS'">Issue status</div>
  <mat-form-field class="w-100-p" appearance="legacy">
    <mat-select formControlName="pendenciesStatus">
      <mat-option [value]="['opened']">
        {{ 'MAINTENANCES.TABS.PENDENCIES.PENDENCY_STATUS.OPENED' | translate }}
      </mat-option>
      <mat-option [value]="['done']">
        {{ 'MAINTENANCES.TABS.PENDENCIES.PENDENCY_STATUS.DONE' | translate }}
      </mat-option>
      <mat-option [value]="''">
        {{ 'MAINTENANCES.FILTERS.PENDENCIES.ALL' | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-divider class="mt-16"></mat-divider>

  <mat-form-field class="mt-16" appearance="legacy">
    <mat-label for="assignees">{{ 'MAINTENANCES.ASSIGNEE_PLACEHOLDER' | translate }}</mat-label>
    <mat-select formControlName="assignees" multiple>
      <mat-select-trigger>
        {{
          filtersForm.get('assignees').value && filtersForm.get('assignees').value.length
            ? getPropertyValue(filtersForm.get('assignees').value[0], assignees, 'name')
            : ''
        }}
        <span *ngIf="filtersForm.get('assignees').value?.length > 1">
          (+{{ filtersForm.get('assignees').value.length - 1 }}
          {{
            filtersForm.get('assignees').value.length === 2
              ? ('MAINTENANCES.ASSIGNEE' | translate)
              : ('MAINTENANCES.ASSIGNEES' | translate)
          }})
        </span>
      </mat-select-trigger>
      <mat-option *ngFor="let assignee of assignees; let $index = index" [value]="assignee.id">
        {{ assignee.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16">
    {{ 'MAINTENANCES.STATUS' | translate }}
  </div>

  <div class="filter-checkbox mt-16" formArrayName="status">
    <mat-checkbox
      *ngFor="let status of STATUS; let $index = index"
      [ngClass]="status.name + '-fg'"
      labelPosition="before"
      [formControlName]="$index"
    >
      <i *ngIf="!status.isMaterialIcon" class="angularjs-fuse-icon mr-32" [ngClass]="status.icon"></i>
      <mat-icon *ngIf="status.isMaterialIcon" class="mr-32">{{ status.icon }}</mat-icon>
      {{ status.translation | translate }}
    </mat-checkbox>
  </div>

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16">
    {{ 'MAINTENANCES.TYPES' | translate }}
  </div>

  <div class="filter-checkbox mt-16" formArrayName="maintenanceTypes">
    <mat-checkbox
      *ngFor="let maintenanceType of maintenanceTypes; let $index = index"
      labelPosition="before"
      [formControlName]="$index"
    >
      {{ maintenanceType.name }}
    </mat-checkbox>
  </div>

  <mat-divider class="mt-16"></mat-divider>

  <ng-container>
    <div class="filter-subtitle mt-16">
      {{ 'MAINTENANCES.FILTERS.DEADLINES.RESPONSE_TITLE' | translate }}
    </div>

    <div class="filter-checkbox" formArrayName="responseDeadlineStatus">
      <mat-checkbox
        *ngFor="let maintenanceDeadlineStatus of maintenanceDeadlineStatusList; index as $index"
        labelPosition="before"
        [formControlName]="$index"
      >
        <div
          class="deadline-status-label"
          [ngClass]="'deadline-status-label--' + (maintenanceDeadlineStatus | camelToKebabCase)"
        ></div>
        {{ maintenanceDeadlineStatus | translateMaintenanceDeadlineStatus }}
      </mat-checkbox>
    </div>

    <mat-divider class="mt-16"></mat-divider>

    <div class="filter-subtitle mt-16">
      {{ 'MAINTENANCES.FILTERS.DEADLINES.SOLUTION_TITLE' | translate }}
    </div>

    <div class="filter-checkbox" formArrayName="solutionDeadlineStatus">
      <mat-checkbox
        *ngFor="let maintenanceDeadlineStatus of maintenanceDeadlineStatusList; index as $index"
        labelPosition="before"
        [formControlName]="$index"
      >
        <div
          class="deadline-status-label"
          [ngClass]="'deadline-status-label--' + (maintenanceDeadlineStatus | camelToKebabCase)"
        ></div>
        {{ maintenanceDeadlineStatus | translateMaintenanceDeadlineStatus }}
      </mat-checkbox>
    </div>
  </ng-container>

  <mat-divider class="mt-16" *ngIf="hasLocationGroupsViewGroupPermission"></mat-divider>

  <div class="filter-subtitle mt-16" *ngIf="hasLocationGroupsViewGroupPermission">
    {{ 'MAINTENANCES.LOCATIONS_GROUPS' | translate }}
  </div>

  <div class="filter-checkbox mt-16" formArrayName="locationsGroups" *ngIf="hasLocationGroupsViewGroupPermission">
    <mat-checkbox
      *ngFor="let locationGroup of locationsGroups; let $index = index"
      labelPosition="before"
      [formControlName]="$index"
    >
      {{ locationGroup.name }}
    </mat-checkbox>
  </div>

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16">
    {{ 'MAINTENANCES.PROBLEMS' | translate }}
  </div>

  <div class="filter-checkbox mt-16" formArrayName="problems">
    <ng-container *ngIf="problems.length">
      <mat-checkbox
        *ngFor="let problem of problems; let $index = index"
        labelPosition="before"
        [formControlName]="$index"
      >
        {{ problem.name }}
      </mat-checkbox>
    </ng-container>
    <ng-container *ngIf="!problems.length">
      <span class="no-items">{{ 'MAINTENANCES.WITHOUT_PROBLEMS' | translate }}</span>
    </ng-container>
  </div>

  <mat-divider class="mt-16" *ngIf="hasLabelViewPermission"></mat-divider>

  <div class="filter-subtitle mt-16" *ngIf="hasLabelViewPermission">
    {{ 'MAINTENANCES.LABELS' | translate }}
  </div>

  <div class="filter-checkbox mt-16" formArrayName="labels" *ngIf="hasLabelViewPermission">
    <ng-container *ngIf="labels.length">
      <mat-checkbox *ngFor="let label of labels; let $index = index" labelPosition="before" [formControlName]="$index">
        <i
          class="angularjs-fuse-icon mr-32"
          [ngClass]="$index === 0 ? ['icon-label-outline'] : ['icon-label', label.color + '-fg']"
        ></i>
        {{ getLabelName(label, $index) }}
      </mat-checkbox>
    </ng-container>
    <ng-container *ngIf="!labels.length">
      <span class="no-items">{{ 'MAINTENANCES.WITHOUT_LABELS' | translate }}</span>
    </ng-container>
  </div>

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16">
    {{ 'MAINTENANCES.AVERAGE_RATINGS' | translate }}
  </div>

  <div class="filter-checkbox mt-16" formArrayName="ratings">
    <mat-checkbox *ngFor="let rating of RATINGS; let $index = index" labelPosition="before" [formControlName]="$index">
      <stars *ngIf="rating.value" class="mr-32" [stars]="rating.value"></stars>
      <span *ngIf="rating.value">{{ 'MAINTENANCES.RATING_OPTIONS.' + rating.translation | translate }}</span>
      <span *ngIf="!rating.value">{{ 'MAINTENANCES.RATING_OPTIONS.NO_RATING' | translate }}</span>
    </mat-checkbox>
  </div>
  <mat-divider class="mt-16 mb-52"></mat-divider>
</form>
